module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-8",
      "lang": "en-US"
    }
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A shrill and discordant voice awakened me from a sound sleep. The flight deck announcement of our initial descent into Los Angeles International Airport. I yawned, stretched my legs and slid open the window blind.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The rising sun glanced off the thick blanket of smog that spread across the horizon and tinted it a mottled brown. Below, an unbroken line of headlights snaked off to the north along the freeway, taillights flashing red in the opposite direction. I blinked my eyes and tried to focus on my watch. Six twenty on a Saturday morning. Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I often said that I hated this city, but that was only a half-truth. At some level it still lived inside my brain, and exposed my inner feelings unexpectedly, like an old lover sharing a smile with me from across the room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I straightened my seat back as directed, and tried to avoid further conversation with the guy sitting next to me by thumbing through the in-flight magazine. It didn’t work.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Coming home?” he asked. A business type returning from a trip he’d won in a sales contest. I’d already heard about it before we took off from Keahole airport.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.” I stared at an article about Herman Melville.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hmmm,” he said. “Connecting, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I shook my head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He gave me the salesman smile.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not much of a talker, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I looked out the window as the wheels skidded against the tarmac. The sky looked like tarnished pewter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” I said. “Not much.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden was waiting outside the security area, standing on his toes to see over the crowd. He was wearing a silk club tie, Allen Edmonds loafers and a gray Louis Roth suit, tailored to diminish his growing paunch.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was the third person off the plane.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“First Class,” he said. “Joining the establishment?” It fell flat, didn’t work with the dark semicircles beneath his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden and I come from different ends of the gene pool. At six two, two hundred ten, I like to get a little leg and elbow room when I can. My brother, on the other hand, packs about the same weight on a five-foot nine-inch frame, and has lost a little more hair every time I see him. Strangers never guessed we were brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure, Valden. Lifestyles of the One Percent,” I countered. He looked like he had enough trouble to deal with.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just kidding, Mike. Got any luggage?” He was eyeballing the two carry-ons I held.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is it,” I said, and let him take my bag. I kept the briefcase. “Let’s go somewhere and talk, maybe get some breakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You know this town better than I do,” he said. “Just tell my driver where to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We walked quickly through the terminal, pushing our way past weekend travelers, and out to the curb where Valden’s limo idled in the white zone. Gray clouds of condensation puffed from the tailpipe and blew away on the brisk November wind. The limo was a brown Lincoln Town Car with a modest stretch. A uniformed driver got out and opened the trunk.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My brother introduced us.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is Jimmy,” he said. “My driver.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We shook hands.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden handed my bag to Jimmy and ducked into the backseat. The driver tucked them away and reached for my briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll keep it in back with me,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fine, sir,” he nodded smartly and closed the trunk. “And where are we headed this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I gave him an address off Figueroa, an old cop hangout that was open all day. I got in the car and Jimmy shut the door behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden pressed the button that raised the privacy screen as we pulled away from the curb. The rich smell of leather and the thick wool carpeting beneath my feet felt like money. That’s how it was supposed to feel in Valden’s world. That’s how you wined and dined your way into sponsoring some of the largest IPOs in the last decade.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It’s also how you became a target.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My brother looked haggard and worn, hardly a trace of the usual slickness and condescension. I was sure other people could see it as clearly as I could. When he spoke, it was almost manic, a sleep-deprived energy that burned like a three-day coke jag.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let me start from the beginning—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I held up my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not here,” I said. “Wait until we get where we’re going.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The walls have ears?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I glanced at the thin privacy panel that separated us from the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right, Valden,” I said. “Eyes, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He looked confused.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What? You mean Jimmy?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I put on my sunglasses and looked out into the early morning glare, then turned back to my brother.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You start by suspecting everybody,” I said. “Sometimes the problem’s right under your nose.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let me tell you a story, Valden.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“See, there was this border guard at a backwater crossing along the border of Slovenia. Every day he sees this young kid pedaling a nice, shiny new bike across the border with a sandbag hanging over the middle of the handlebars. After a couple days of watching the kid, the guard stops him, makes him dump out the bag. Surprised as hell, he finds it’s only sand. He lets the kid go, but makes sure to keep an eye on him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He watches the kid for a few more days. Same thing happens. Every day, the kid comes through with a bag of sand over the handlebars. So the guard stops him again, makes the kid dump out the bag. Again, it’s only sand. It drives the guard nuts.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Finally, one day he stops the kid and makes a deal with him. ‘I know you’re smuggling something valuable through here,’ he tells the kid. ‘But I don’t know what it is. Tell me what you’re bringing across, and I promise never to stop you again.’ The kid sizes him up, smiles and says, ‘Bicycles.’”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden blinked, responded only with a blank look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Write down the names of everyone who knows you’re in town. Everyone who knew you were coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I looked hard into his tired eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Might as well,” I said. “Because we aren’t going to do any more talking inside this car.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He started to say something more, but I stopped him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The list, please,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He stared for a long time, past the tinted windows at the long blocks of tall buildings that lined Century Boulevard. When he finally turned back to me, his expression betrayed his loneliness.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The place was called the One-Oh-Seven. A cop reference to the ten-seven radio code that meant "), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Out of Service.")]), _vm._v(" I watched the guys at a table by the window throw us the stink eye as the limo glided to a stop at the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The kitchen was always open, always busy, and nondescript in every, sense. Even at this hour on a Saturday there were cops coming off shift preparing to go home, some grabbing breakfast before going on duty. Most were in uniform, though a handful wore plain clothes. In the back was a small room that they used for private parties, poker, and after-hours drinking. Every club needs a clubhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jimmy appeared at the curb on Valden’s side and opened the door for him. My brother looked past him and gave the sixties-era river-rock facade a grim once-over. I knew what he was thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As I slid across the seat, Valden made for the entrance. But when I got out of the car, Jimmy the driver latched on to my elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know who you think you are, but I resent what you said to Mr. Van de Groot in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was close enough that I could smell his breath: Dentyne and cigarettes. I jacked my arm away and faced him squarely.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come again?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had startled him, but he tentatively held his ground.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m a loyal employee,” he said, his jaw stiff. “I’m a good man and a good driver. I would never do anything to hurt Mr. Van de Groot.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I took off my sunglasses and let him see my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Good to know,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jimmy nodded, his honor defended.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I took a step toward the restaurant, then halted. I turned back to the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You proved my point, though, didn’t you Jimmy?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Traffic blew past him on Figueroa, ruffling his hair. He cocked his head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How would you know what I said to my brother back there?” I said, and followed Valden into the One-Oh-Seven.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My brother waited just inside, drumming his fingers on a glass counter case that displayed an assortment of breath mints and antacid tablets, waiting for the hostess I knew would never appear. I steered him to the back of the place, pointed to an empty seat in a booth against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll be right back,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I pushed through the swinging doors that led to the kitchen and found a waitress I still knew from back when. She hugged me, grabbed three plates of eggs, toast and bacon, and told me she’d be back in a minute. Through grease-dimmed diamonds of glass set into the kitchen doors, I watched Valden pick imaginary lint from the sleeves of his suit coat. Tables full of cops, in uniform and out, took turns glaring at him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When the waitress came back, I was holding the keys I’d lifted from the hook hidden beneath the counter. The keys to the private room in back. I held them up where she could see them, flashed a question with my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She kissed me on the cheek and whispered in my ear.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We miss you around here, honey.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The back room was smaller than I remembered, windowless, and smelled of tobacco smoke, stale beer and testosterone. The handles of two taps stood up behind a truncated wooden bar top, rows of clouded glassware on the counter behind. There was seating for maybe forty people on mismatched furniture set upon a faded checkerboard of green-and-white linoleum. Framed photos of cops, yellowed by age, covered two walls; a pair of dartboards and an oversized TV occupied the others. Dust motes floated on beams of dull incandescent light that glowed inside ceiling fixtures that hadn’t been cleaned since I was a rookie.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden’s eyes darted around the place; his lips made a nervous smacking sound.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I took a table in the back corner, the one that faced the door, and pulled my laptop from the briefcase, set it on a scratched and dented table. Valden handed me the DVD he had told me about on the phone and paced the floor as I watched it. Every now and then I’d catch him looking over at me, gauging my reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It started with about twenty seconds of video footage of my brother and an unidentified young woman standing in an elevator. Her face was turned to the side, but had the look of someone who’d ridden that car before. At the right side of the frame, the doors eased closed, and floor numbers began to click by on the digital readout. They wasted no time. By the time the indicator read "), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("three,")]), _vm._v(" Valden had pressed the woman into the corner of the car and begun running his hands over her breasts and buttocks. By the fifth floor, he had buried his face into the crook of her neck and was working the hem of her dress high enough to see thigh-length stockings and a garter. She had one shapely calf wrapped around the back of his thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The video abruptly went black, images on the screen replaced with a written demand that $3 million dollars be wired to a numbered account that was sure to reside in the Cook or Cayman Islands. It went on to say that further contact would be made on Sunday, when Valden would be provided the number of that account. If the funds had not cleared the wire by noon local time on Monday, then every US news network, business magazine, and major client of Van de Groot Capital would be sent a copy of the unedited video, and given the name of a web address where the full version would be posted for anyone in the world to access.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The words disappeared from the screen as suddenly as they had appeared, where my brother and his new friend were back in action.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden stopped pacing, took a seat in the corner as I watched the last of the footage: an image of him and the elevator woman entering a room on the thirty-fifth floor, the time code clearly marked 23:49:17. Nearly midnight. This was followed by a jump cut to 01:22:44, which showed the woman leaving Valden’s room, adjusting a shoulder strap and blowing a final kiss into the room. The number on the door was as clearly visible as was Valden’s face when he leaned out and kissed her one last time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The screen went dark, then flashed an address: that of my brother’s New York home, followed by the names of his wife and children.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My stomach was an icy pit, and I heard the rush of blood in my ears.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I turned to face my brother.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The thing with blackmailers is,” I said, “you’ve got to pull them out by the roots or they keep coming back. You understand that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Valden nodded, staring a hole in the linoleum.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No mention of how they’re going to contact you on Sunday,” I said. “Any thoughts?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By the look on my brother’s face, I knew the other shoe was about to drop.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That political fund-raiser I mentioned to you on the phone?” he began. “It’s on Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who is it for?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Congressman Kelleher.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Bill Kelleher?” I knew his name from the news. Everybody with a television and an IQ over fourteen knew who he was by now. He held some serious views about immigration and foreign trade, and wasn’t shy about sharing them, establishing his bona fides early and often as a viable contender in the next round of presidential elections.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Where?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Phillip Lennox’s estate.” Another name familiar to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I didn’t say it then, but I knew the blackmailers meant to reach out to Valden at that function. It was the smart thing for them to do. It would demonstrate to my brother they were deadly serious, that they could get to him anywhere they chose, and would underscore my brother’s abject dread of public humiliation. They knew it would put the fear of God into him, and at precisely the right time, mere hours before the $3 million was to be transferred.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There’s no guarantee I can help you,” I said. “I’m not a cop. I’m barely a PI, and there’s no fucking time on the clock. You get that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m out of options, Mike.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You know there’s a simple way out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He looked at me out of the corner of his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And what would—No.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tell her, Valden. Confess this thing to LeeAnn, take your licks and be done with it. Salvage your family and your name. And the company name.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s not going to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My eyes roamed back to the laptop where the names of his wife and family still glowed in stark block letters.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re willing to risk bringing a shitstorm down on yourself, your family and the company our grandfather built out of nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He held my gaze for the first time since I’d arrived, with eyes that were glazed and shot through with fatigue and uncertainty. I hoped he was weighing the potential cost of his hubris.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I punched the eject button, slipped the disk from my computer, and packed them both into my briefcase next to the empty place where my Beretta should have been. Thanks to bin Laden—that vile and despicable fuck-stick—traveling with firearms wasn’t as simple as it had once been, even if you were former law enforcement and had all your paperwork in order. I felt naked and ill-equipped for making my way around a city where you could get a slug planted in your brainpan just for mistiming a lane change.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Muffled racket from the kitchen thrummed against the walls of the tiny room, and somehow charged the emptiness we found ourselves in. I looked once again at my brother. He was rubbing his forehead with one hand, flexing a fist with the other. I wondered whether he had the stones for what was coming.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c998e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504082006-8.vue
// module id = 99
// module chunks = 0